import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasAccessToken } from '@/lib/token-storage'
import ContaPage from '@/pages/conta/conta-page'

export const Route = createFileRoute('/conta')({
  beforeLoad: () => {
    if (!hasAccessToken()) {
      throw redirect({ to: '/' })
    }
  },
  component: ContaPage,
})
